
import React from 'react';
import OnboardingForm from "@/components/onboarding/OnboardingForm";
import { useParams } from "react-router-dom";

const OnboardingPage = () => {
  const { formId } = useParams();
  
  console.log("OnboardingPage rendered with formId:", formId);
  
  return <OnboardingForm formId={formId} />;
};

export default OnboardingPage;
